import ToolbarField from './ToolbarField'
import FlagCellRenderer from './FlagCellRenderer.vue'
import SelectCellEditor from './SelectCellEditor.vue'
import BoolCellRenderer from './BoolCellRenderer.vue'
import DecimalCellRenderer from './DecimalCellRenderer.vue'
import BoolCellEditor from './BoolCellEditor.vue'
import DateCellEditor from './DateCellEditor.vue'
import EmailCellRenderer from './EmailCellRenderer.vue'
import LinkCellRenderer from './LinkCellRenderer.vue'
// import HeaderRender from './HeaderRender.vue'

export default {
    selectCellEditor: SelectCellEditor,
    boolCellRender: BoolCellRenderer,
    boolCellEditor: BoolCellEditor,
    decimalCellRender: DecimalCellRenderer,
    dateCellEditor: DateCellEditor,
    flagCellRenderer: FlagCellRenderer,
    linkCellRenderer: LinkCellRenderer,
    emailCellRenderer: EmailCellRenderer,
    // agColumnHeader: HeaderRender,
    toolbarField: ToolbarField,
}
